import React from "react";
import { Progress as MantineProgress } from "@mantine/core";
import { ProgressProps } from "@mantine/core";
import classes from "./index.module.css";

const Progress: React.FC<ProgressProps> = props => {
  return <MantineProgress {...props} classNames={classes} aria-hidden="true" />;
};

export default Progress;
